<div *ngIf="weight; then thenBlock; else elseBlock"></div>
<ng-template #thenBlock
  ><report-value
    [ngClass]="{ 'text-right': textRight, 'text-center': !textRight }"
    >{{ weight | number: "1.2-2" }}</report-value
  ></ng-template
>
<ng-template #elseBlock><report-value>- -</report-value></ng-template>
